<div class="education-content-page">
  <div class="education-content-page__introduction"
   *ngIf="content.introduction">
    <div class="education-content-page__introduction__title">
      {{ content.introduction.header.title }}
    </div>
    <div
      class="education-content-page__introduction__subtitle"
      [innerHTML]="content.introduction.header.content"
    ></div>
    <div class="education-content-page__introduction__gallery">
      <aura-gallery
        [content]="content.introduction.requirements"
      ></aura-gallery>
    </div>
    <div class="education-content-page__introduction__header-note">
      {{ content.introduction.note }}
    </div>
  </div>
  <div
    class="education-content-page__sections"
    *ngFor="let section of content.sections"
  >
    <aura-divider></aura-divider>
    <div class="education-content-page__sections__title">
      {{ section.header.title }}
    </div>
    <div
      class="education-content-page__sections__subtitle"
      *ngIf="section.header.subtitle"
    >
      {{ section.header.subtitle }}
    </div>
    <div class="education-content-page__sections__toggle-area">
      <aura-toggle-area
        *ngFor="let item of section.items"
        auraCustomStyles
        [entryItem]="item.entry"
        [separator]="false"
        [stylesArray]="getStyles(item.entry.icon)"
      >
        <div class="education-content-page__sections__toggle-area__wrap">
          <div class="education-content-page__sections__toggle-area__detail">
            {{ item.detail }}
          </div>
          <div
            class="education-content-page__sections__toggle-area__tier-miles"
            *ngIf="item.tierMiles"
          >
            <aura-details-entry
              *ngFor="let tierMile of item.tierMiles"
              [detailsEntry]="tierMile"
            ></aura-details-entry>
          </div>
          <div *ngIf="item.action?.url">
            <a
              class="education-content-page__sections__toggle-area__link"
              *ngIf="item.action"
              [href]="item.action.url"
              target="_blank"
            >
              {{ item.action.label }}
            </a>
          </div>
        </div>
      </aura-toggle-area>
    </div>
    <div
      *ngIf="section.note"
      class="education-content-page__sections__note-section"
    >
      {{ section.note }}
    </div>

    <a
      class="education-content-page__sections__link"
      [href]="section.action.url"
      target="_blank"
    >
      {{ section.action.label }}
    </a>
  </div>
</div>
